import { defineComponent as _defineComponent } from 'vue'
import { ref } from "@nuxtjs/composition-api";


export default /*#__PURE__*/_defineComponent({
  __name: 'RetailerProductModal',
  props: {
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {



const isOpen = ref(false);

return { __sfc: true,isOpen }
}

})